import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';
import { auth, db } from './firebase';

const serialiseDocument = (snapshot) => {
  const data = snapshot.data();
  return {
    id: snapshot.id,
    ...data,
    createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : data.createdAt,
    updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate().toISOString() : data.updatedAt,
  };
};

const requireAuth = () => {
  if (!auth.currentUser) {
    throw new Error('You must be signed in to access Sharabl data.');
  }
};

export const firestoreService = {
  async list(collectionName, constraints = []) {
    requireAuth();
    const collectionRef = collection(db, collectionName);
    const snapshot = await getDocs(query(collectionRef, ...constraints, orderBy('updatedAt', 'desc')));
    return snapshot.docs.map(serialiseDocument);
  },

  async get(collectionName, id) {
    requireAuth();
    const snapshot = await getDoc(doc(db, collectionName, id));
    return snapshot.exists() ? serialiseDocument(snapshot) : null;
  },

  async create(collectionName, data) {
    requireAuth();
    const now = new Date().toISOString();
    const payload = {
      ...data,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    if (data.id) {
      await setDoc(doc(db, collectionName, data.id), payload);
      return { ...data, id: data.id, createdAt: now, updatedAt: now };
    }

    const created = await addDoc(collection(db, collectionName), payload);
    return { ...data, id: created.id, createdAt: now, updatedAt: now };
  },

  async update(collectionName, id, data) {
    requireAuth();
    const now = new Date().toISOString();
    await setDoc(doc(db, collectionName, id), {
      ...data,
      updatedAt: serverTimestamp(),
    }, { merge: true });

    return { ...data, id, updatedAt: now };
  },

  async remove(collectionName, id) {
    requireAuth();
    await deleteDoc(doc(db, collectionName, id));
    return true;
  },
};
